module.exports = "/_next/static/images/c6b1ff82e4c75161fa4ba6d73b7c9ade-challenge-the-system-xs@2x.jpg.webp";